import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbTabsetModule, NbRouteTabsetModule, NbStepperModule, NbButtonModule, NbListModule, NbAccordionModule, NbUserModule, NbCardModule, NbIconModule, NbInputModule, NbTreeGridModule, NbSpinnerModule, NbCheckboxModule } from '@nebular/theme';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { ThemeModule } from '../../@theme/theme.module';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentstModule } from '../../shared/components/components.module';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { BoletoPrePagoComponent } from './boleto-pre-pago.component';
import { BoletoPrePagoRoutingModule } from './boleto-pre-pago-routing.module'
import { SolicitePedidoPrePagoComponent } from './solicite-pedido-pre-pago/solicite-pedido-pre-pago.component';
import { GeraPedidoPrePagoComponent } from './gera-pedido-pre-pago/gera-pedido-pre-pago.component';
import { ModalPagamentoComponent } from './solicite-pedido-pre-pago/modal-pagamento/modal-pagamento.component';
import { ModalPedidoGeradoComponent } from './gera-pedido-pre-pago/modal-pedido-gerado/modal-pedido-gerado.component';
import { ModalAvisoComponent } from './solicite-pedido-pre-pago/modal-aviso/modal-aviso.component';

@NgModule({
  imports: [
    CommonModule,
    BoletoPrePagoRoutingModule,
    NbCheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbRouteTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbAccordionModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    NbTreeGridModule,
    Ng2SmartTableModule,
    ThemeModule,
    MyDatePickerModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    ComponentstModule,
    CurrencyMaskModule, 
  ],
  exports: [
    MyDatePickerModule,
  ],
  entryComponents: [ 
    ModalPagamentoComponent,
    ModalPedidoGeradoComponent,
    ModalAvisoComponent,
  ],
  declarations: [
    BoletoPrePagoComponent,  
    SolicitePedidoPrePagoComponent,
    GeraPedidoPrePagoComponent,
    ModalPagamentoComponent,
    ModalPedidoGeradoComponent,
    ModalAvisoComponent,
  ],
})

export class BoletoPrePagoModule { }
